import React, { Component } from "react";
import intl from "react-intl-universal";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      isFPForm: true,
      isEmailFailed: false,
      isLoading: false
    };
  }

  validateForm() {
    return this.state.email.length > 0;
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "changePasswordRequest", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        Email: this.state.email
      })
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result.toString().toLowerCase() === "success") {
          this.setState({ isFPForm: false });
          this.setState({ isLoading: false });
        } else {
          this.setState({ isEmailFailed: true });
          this.setState({ isLoading: false });
        }
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
      });
  };

  renderForgotPasswordForm() {
    return (
      <DivsPattern headerText={intl.get("Forgot_Password_Title")}>
        <form className="form-signin" onSubmit={this.handleSubmit}>
          <div className="form-label-group">
            <input
              type="email"
              onChange={event => this.setState({ email: event.target.value })}
              className="form-control"
              placeholder={intl.get("Eamil_Address_Test")}
              value={this.state.email}
              autoFocus
              required
            />
          </div>
          <LoaderButton
            className="btn-lg btn btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2 btn-login"
            type="submit"
            text={intl.get("Send")}
            isLoading={this.state.isLoading}
            loadingText={intl.get("Sending_An_Email")}
          />
        </form>
        {this.state.isEmailFailed ? (
          <div id="divError">
            <span style={{ color: "red" }}>
              {intl.get("Forgot_Password_Failed_To_Send")}
            </span>
          </div>
        ) : null}
      </DivsPattern>
    );
  }

  renderCheckYourEmail() {
    return (
      <DivsPattern headerText={intl.get("Forgot_Password_Title")}>
        <div className="form-label-group">
          <p>
            {intl.get("Forgot_Password_Email", { email: this.state.email })}
          </p>
          <div className="text-center">
            <LoaderButton
              className="small ResendButton"
              text={intl.get("Forgot_Password_Resend")}
              href="#"
              isLoading={this.state.isLoading}
              onClick={this.handleSubmit}
              loadingText={intl.get("Resending_An_Email")}
            />
          </div>
        </div>
      </DivsPattern>
    );
  }

  render() {
    return this.state.isFPForm
      ? this.renderForgotPasswordForm()
      : this.renderCheckYourEmail();
  }
}

export default ForgotPassword;
